import type { ReadonlyRecord } from '../../../utils'

export const extractDataTestId = (props: ReadonlyRecord<never, unknown>): string | null =>
    ('data-testid' in props && typeof props['data-testid'] === 'string' && props['data-testid']) || null
